var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "a-card",
        {
          attrs: {
            title:
              _vm.mode === "create"
                ? _vm.$t("lbl_invoices_prepayment_debit_memo")
                : _vm.$t("lbl_detail_invoices_prepayment_debit_memo")
          }
        },
        [
          _c(
            "a-form",
            {
              attrs: {
                form: _vm.form,
                "wrapper-col": { span: 12 },
                "label-col": { span: 8 }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: [16, 16], type: "flex" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.storeDetail.documentNumber,
                              expression: "storeDetail.documentNumber"
                            }
                          ],
                          attrs: {
                            label: _vm.$t(_vm.formRules.invoiceNumber.label)
                          }
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.invoiceNumber.decorator,
                                expression: "formRules.invoiceNumber.decorator"
                              }
                            ],
                            attrs: {
                              name: _vm.formRules.invoiceNumber.name,
                              placeholder: _vm.$t(
                                _vm.formRules.invoiceNumber.placeholder
                              ),
                              autocomplete: "off",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.invoiceType.label)
                          }
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.invoiceType.decorator,
                                expression: "formRules.invoiceType.decorator"
                              }
                            ],
                            attrs: { disabled: "" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.show.returnNumber,
                              expression: "show.returnNumber"
                            }
                          ],
                          attrs: {
                            label: _vm.$t(_vm.formRules.returnNumber.label)
                          }
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.returnNumber.decorator,
                                expression: "formRules.returnNumber.decorator"
                              }
                            ],
                            attrs: {
                              name: _vm.formRules.returnNumber.name,
                              placeholder: _vm.$t(
                                _vm.formRules.returnNumber.placeholder
                              ),
                              autocomplete: "off",
                              disabled: _vm.disabled.returnNumber
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.$t(_vm.formRules.branch.label) }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.branch.decorator,
                                  expression: "formRules.branch.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.formRules.branch.name,
                                placeholder: _vm.$t(
                                  _vm.formRules.branch.placeholder
                                ),
                                disabled: _vm.disabled.branch,
                                showSearch: true,
                                "filter-option": false,
                                loading: _vm.loading.branch,
                                allowClear: true
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "branch")
                                },
                                change: function(value) {
                                  return _vm.setFormMeta({ branchId: value })
                                }
                              }
                            },
                            _vm._l(_vm.optBranch, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.$t(_vm.formRules.currency.label) }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.currency.decorator,
                                  expression: "formRules.currency.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.formRules.currency.name,
                                placeholder: _vm.$t(
                                  _vm.formRules.currency.placeholder
                                ),
                                disabled: _vm.disabled.currency,
                                showSearch: true,
                                "filter-option": false,
                                loading: _vm.loading.currency,
                                allowClear: true
                              },
                              on: {
                                change: _vm.onChangeCurrency,
                                search: function(value) {
                                  return _vm.searchData(value, "currency")
                                }
                              }
                            },
                            _vm._l(_vm.optCurrency, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.show.rate,
                              expression: "show.rate"
                            }
                          ],
                          attrs: { label: _vm.$t(_vm.formRules.rate.label) }
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.rate.decorator,
                                expression: "formRules.rate.decorator"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              name: _vm.formRules.rate.name,
                              placeholder: _vm.$t(
                                _vm.formRules.rate.placeholder
                              ),
                              formatter: _vm.formatterNumber,
                              parser: _vm.reverseFormatNumber,
                              min: 1,
                              precision: _vm.storeBaseDecimalPlace
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.invoiceDate.label)
                          }
                        },
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.invoiceDate.decorator,
                                expression: "formRules.invoiceDate.decorator"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              placeholder: _vm.$t(
                                _vm.formRules.invoiceDate.placeholder
                              ),
                              format: _vm.DEFAULT_DATE_FORMAT,
                              disabled: _vm.disabled.invoiceDate
                            },
                            on: { change: _vm.onChangeInvoiceDate }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.accountingDate.label)
                          }
                        },
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.accountingDate.decorator,
                                expression: "formRules.accountingDate.decorator"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              placeholder: "",
                              format: _vm.DEFAULT_DATE_FORMAT,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.payableAccount.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.payableAccount.decorator,
                                  expression:
                                    "formRules.payableAccount.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.formRules.payableAccount.name,
                                placeholder: _vm.$t(
                                  _vm.formRules.payableAccount.placeholder
                                ),
                                disabled: _vm.disabled.payableAccount,
                                "show-search": "",
                                "filter-option": false,
                                loading: _vm.loading.payableAccount,
                                "allow-clear": "",
                                dropdownMatchSelectWidth: false
                              },
                              on: {
                                search: _vm.onSearchPayableAccount,
                                change: function(value) {
                                  return _vm.setFormMeta({
                                    payableAccId: value
                                  })
                                }
                              }
                            },
                            _vm._l(_vm.dataListPayableAccount, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.isLuxuryGoods.label)
                          }
                        },
                        [
                          _c("a-switch", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.isLuxuryGoods.decorator,
                                expression: "formRules.isLuxuryGoods.decorator"
                              }
                            ],
                            attrs: {
                              name: _vm.formRules.isLuxuryGoods.name,
                              disabled: _vm.disabled.isLuxuryGoods
                            },
                            on: { change: _vm.handleLuxuryGoodsChange }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.supplierName.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.supplierName.decorator,
                                  expression: "formRules.supplierName.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.formRules.supplierName.name,
                                placeholder: _vm.$t(
                                  _vm.formRules.supplierName.placeholder
                                ),
                                disabled: _vm.disabled.supplierName,
                                showSearch: true,
                                "filter-option": false,
                                loading: _vm.loading.supplierName,
                                allowClear: true
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "supplierName")
                                },
                                change: _vm.onChangeSupplier
                              }
                            },
                            _vm._l(_vm.dataListSupplier, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.supplierBillTo.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.supplierBillTo.decorator,
                                  expression:
                                    "formRules.supplierBillTo.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.formRules.supplierBillTo.name,
                                placeholder: _vm.$t(
                                  _vm.formRules.supplierBillTo.placeholder
                                ),
                                disabled: _vm.disabled.supplierBillTo,
                                "option-filter-prop": "children",
                                "filter-option": _vm.useLocalFilter,
                                dropdownMatchSelectWidth: false,
                                allowClear: true,
                                "show-search": ""
                              }
                            },
                            _vm._l(_vm.dataListSupplierBillTo, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.show.poNumber,
                              expression: "show.poNumber"
                            }
                          ],
                          attrs: { label: _vm.$t(_vm.formRules.poNumber.label) }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.poNumber.decorator,
                                  expression: "formRules.poNumber.decorator"
                                }
                              ],
                              attrs: {
                                name: _vm.formRules.poNumber.name,
                                placeholder: _vm.$t(
                                  _vm.formRules.poNumber.placeholder
                                ),
                                disabled: _vm.disabled.poNumber,
                                showSearch: true,
                                "filter-option": false,
                                loading: _vm.loading.poNumber,
                                allowClear: true
                              },
                              on: {
                                search: function(value) {
                                  return _vm.searchData(value, "poNumber")
                                },
                                change: _vm.onChangePo
                              }
                            },
                            _vm._l(_vm.dataListPoNumber, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(_vm.formRules.assetCode.label)
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: _vm.formRules.assetCode.decorator,
                                  expression: "formRules.assetCode.decorator"
                                }
                              ],
                              attrs: {
                                disabled:
                                  _vm.disabled.assetCode ||
                                  !_vm.form.getFieldValue("poNumber"),
                                "show-search": "",
                                "filter-option": false,
                                loading: _vm.loading.assetCode,
                                "allow-clear": ""
                              },
                              on: {
                                search: _vm.onSearchAsset,
                                change: function(value) {
                                  return _vm.setFormMeta({ assetId: value })
                                }
                              }
                            },
                            _vm._l(_vm.optAssetCode, function(data) {
                              return _c(
                                "a-select-option",
                                { key: data.key, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.label) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.label) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.show.poNumber,
                              expression: "show.poNumber"
                            }
                          ],
                          attrs: { label: _vm.$t(_vm.formRules.poType.label) }
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.poType.decorator,
                                expression: "formRules.poType.decorator"
                              }
                            ],
                            attrs: {
                              name: _vm.formRules.poType.name,
                              autocomplete: "off",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm.storeDetail.journalId
                        ? _c(
                            "a-form-item",
                            { attrs: { label: _vm.$t("lbl_journal_number") } },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "generaljournal.detail",
                                      params: { id: _vm.storeDetail.journalId }
                                    }
                                  }
                                },
                                [
                                  _c("a-button", { attrs: { type: "link" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.storeDetail.journalNo) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              _vm.formRules.invoiceDescription.label
                            )
                          }
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value:
                                  _vm.formRules.invoiceDescription.decorator,
                                expression:
                                  "formRules.invoiceDescription.decorator"
                              }
                            ],
                            attrs: {
                              name: _vm.formRules.invoiceDescription.name,
                              autocomplete: "off",
                              disabled: _vm.disabled.invoiceDescription,
                              rows: 4
                            }
                          }),
                          _c("character-length", {
                            attrs: {
                              value: _vm.form.getFieldValue(
                                "invoiceDescription"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.show.status,
                              expression: "show.status"
                            }
                          ],
                          attrs: { label: _vm.$t(_vm.formRules.status.label) }
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: _vm.formRules.status.decorator,
                                expression: "formRules.status.decorator"
                              }
                            ],
                            attrs: {
                              name: _vm.formRules.status.name,
                              placeholder: _vm.$t(
                                _vm.formRules.status.placeholder
                              ),
                              autocomplete: "off",
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-tabs",
            {
              attrs: {
                "default-active-key": _vm.activeTabPane,
                activeKey: _vm.activeTabPane
              },
              on: { change: _vm.handleChangeMenu }
            },
            _vm._l(_vm.columnTabPane, function(item) {
              return _c(
                "a-tab-pane",
                { key: item },
                [
                  _c(
                    "span",
                    { attrs: { slot: "tab" }, slot: "tab" },
                    [
                      _vm._v(" " + _vm._s(item) + " "),
                      _c("a-icon", {
                        staticStyle: { color: "red" },
                        attrs: { type: "tag" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form",
                    {
                      attrs: {
                        form: _vm.formTable,
                        "label-align": "left",
                        "wrapper-col": { span: 8 },
                        "label-col": { span: 5 }
                      }
                    },
                    [
                      _c("TableDetailsPrepayment", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeTabPane === "Details",
                            expression: "activeTabPane === 'Details'"
                          }
                        ],
                        attrs: { disabled: _vm.disabled }
                      }),
                      _c("TableTaxDetailsPrepayment", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeTabPane === "Tax Details",
                            expression: "activeTabPane === 'Tax Details'"
                          }
                        ],
                        attrs: { disabled: _vm.disabled }
                      }),
                      _c("TableStatusPrepayment", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeTabPane === "Status",
                            expression: "activeTabPane === 'Status'"
                          }
                        ]
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _c(
            "a-descriptions",
            { attrs: { bordered: "", size: "small" } },
            [
              _c("a-descriptions-item", [
                _c(
                  "p",
                  {
                    staticClass: "text-right mb-0",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lbl_subtotal")) + " ")]
                ),
                _vm._v(
                  " " + _vm._s(_vm._f("currency")(_vm.storeSubtotal)) + " "
                )
              ]),
              _c("a-descriptions-item", [
                _c(
                  "p",
                  {
                    staticClass: "text-right mb-0",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lbl_tax_base_dpp")) + " ")]
                ),
                _vm._v(" " + _vm._s(_vm._f("currency")(_vm.storeTaxBase)) + " ")
              ]),
              _c("a-descriptions-item", [
                _c(
                  "p",
                  {
                    staticClass: "text-right mb-0",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lbl_total_tax")) + " ")]
                ),
                _vm._v(
                  " " + _vm._s(_vm._f("currency")(_vm.storeTotalTax)) + " "
                )
              ]),
              _c("a-descriptions-item", [
                _c(
                  "p",
                  {
                    staticClass: "text-right mb-0",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lbl_total")) + " ")]
                ),
                _vm._v(
                  " " + _vm._s(_vm._f("currency")(_vm.storeTotalPayment)) + " "
                )
              ])
            ],
            1
          ),
          _c("a-divider"),
          _c(
            "div",
            { staticClass: "text-right mt-2" },
            [
              _c(
                "a-space",
                [
                  _c("a-button", { on: { click: _vm.back } }, [
                    _vm._v(" " + _vm._s(_vm.$t("lbl_back")) + " ")
                  ]),
                  _vm.allowRejectOrApprove &&
                  _vm.$can("approve", "invoice-ap-prepayment")
                    ? [
                        _c(
                          "a-popconfirm",
                          {
                            attrs: {
                              title: _vm.$t("pop_confirmation"),
                              "ok-text": _vm.$t("lbl_yes"),
                              "cancel-text": _vm.$t("lbl_no")
                            },
                            on: {
                              confirm: function($event) {
                                return _vm.handleReject(_vm.docId)
                              }
                            }
                          },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "danger",
                                  loading: _vm.loading.reject
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("lbl_reject")) + " ")]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.allowRejectOrApprove &&
                  _vm.$can("approve", "invoice-ap-prepayment")
                    ? _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.loading.approve
                          },
                          on: {
                            click: function($event) {
                              return _vm.validateForm("approve")
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_approve")) + " ")]
                      )
                    : _vm._e(),
                  _vm.allowCancel && _vm.$can("cancel", "invoice-ap-prepayment")
                    ? [
                        _c(
                          "a-popconfirm",
                          {
                            attrs: {
                              title: _vm.$t("pop_confirmation"),
                              "ok-text": _vm.$t("lbl_yes"),
                              "cancel-text": _vm.$t("lbl_no")
                            },
                            on: {
                              confirm: function($event) {
                                return _vm.handleCancel(_vm.docId)
                              }
                            }
                          },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "danger",
                                  loading: _vm.loading.cancel
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("lbl_cancel")) + " ")]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.show.submit && _vm.$can("create", "invoice-ap-prepayment")
                    ? _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.loading.submit
                          },
                          on: {
                            click: function($event) {
                              return _vm.validateForm("submit")
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_submit")) + " ")]
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }